export enum ReconciliationsAccountTypes {
  OMNIBUS = 'Omnibus',
  CLEARING = 'Clearing',
}
